import { space } from 'folio-common-components';
import * as React from 'react';
import { ContinueLink } from '../../components/ContinueLink';
import { EditableCeoSummary } from '../../components/EditableCeoSummary';
import { BoardMemberList, Chair } from '../../components/RoleList';
import { PageCard, Section } from '../../components/Section';
import { SimpleBoardSummary } from '../../components/SimpleBoardSummary';
import { TogglableCompanyAddressForm } from '../../components/TogglableCompanyAddressForm';
import { PageHeading } from '../../components/page-heading';
import { SectionHeading } from '../../components/section-heading';
import { Labels } from '../../messages';
import { pageMap } from '../../paths';
import { useActions, useSelector } from '../../state';
import { EmploymentForm } from './EmploymentForm';
import { OrgTransferForm } from './org-transfer-form';

const Editable: React.FC = () => {
  return (
    <>
      <Section>
        <SectionHeading id="board">Styre</SectionHeading>
        <p>
          Du må ha en styreleder. Om det skal være fler i styret, bestemmer du
          selv.
        </p>
        <Chair />
        <BoardMemberList />
      </Section>

      <Section>
        <SectionHeading>Daglig leder</SectionHeading>
        <EditableCeoSummary />
      </Section>
    </>
  );
};

const StepPage4: React.FC = () => {
  const { editorActions } = useActions();
  const hasEditableBoard = useSelector(e => e.editor.hasEditableBoard);
  return (
    <>
      <PageCard>
        <PageHeading>Drift</PageHeading>

        <Section>
          <SectionHeading>Forretnings&shy;adresse</SectionHeading>
          <TogglableCompanyAddressForm />
        </Section>

        <Section>
          <SectionHeading>Viderefører du en virksomhet?</SectionHeading>
          <OrgTransferForm />
        </Section>

        <Section>
          <SectionHeading>Skal selskapet ha ansatte fra start?</SectionHeading>
          <div css={space([16], 'margin-top')}>
            <EmploymentForm />
          </div>
        </Section>

        {hasEditableBoard ? <Editable /> : <SimpleBoardSummary />}
      </PageCard>

      <ContinueLink
        to={pageMap.step5}
        onClick={() => editorActions.markPageForValidation('step4')}
      >
        <Labels.Onward />
      </ContinueLink>
    </>
  );
};

// React.lazy only supports default exports:
// https://reactjs.org/docs/code-splitting.html#named-exports
// eslint-disable-next-line import/no-default-export
export default StepPage4;
